module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ryan Mobley","short_name":"starter","start_url":"/","background_color":"#1848b3","theme_color":"#1848b3","display":"minimal-ui","icon":"src/images/favi.jpg"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
